import { render, staticRenderFns } from "./Excepciones.vue?vue&type=template&id=ca6474c6"
import script from "./Excepciones.vue?vue&type=script&lang=js"
export * from "./Excepciones.vue?vue&type=script&lang=js"
import style0 from "./Excepciones.vue?vue&type=style&index=0&id=ca6474c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports